// Rotates the public sample Donkey's Verdict between the three fictional personas
// so different visitors land on a relevant example. Kept consistent per browser
// session so every "See a sample" button in one visit points to the same persona.
const SAMPLES = ["start", "transform", "grow"];

export function pickSampleSlug() {
  try {
    const key = "hd_sample_slug";
    let s = sessionStorage.getItem(key);
    if (!s || !SAMPLES.includes(s)) {
      s = SAMPLES[Math.floor(Math.random() * SAMPLES.length)];
      sessionStorage.setItem(key, s);
    }
    return s;
  } catch {
    return SAMPLES[Math.floor(Math.random() * SAMPLES.length)];
  }
}
